import { motion } from "framer-motion";
import { Zap, BrainCircuit, Globe2, Gift } from "lucide-react";

const chapters = [
  {
    num: "01",
    title: "Lightning Speed Duels",
    copy: "Real-time 1v1 trivia battles. Ten seconds a question, fastest correct answer steals the round. No mercy, no lag, pure reflex.",
    icon: Zap,
    color: "#00F0FF",
  },
  {
    num: "02",
    title: "Adaptive Quiz Engine",
    copy: "An engine that learns your weaknesses and sharpens your strengths. Every duel makes the next one smarter — and so do you.",
    icon: BrainCircuit,
    color: "#FF007A",
  },
  {
    num: "03",
    title: "Global Leaderboards",
    copy: "Climb city, country and world ranks. Season resets keep the hunt alive and the crown contested every single month.",
    icon: Globe2,
    color: "#39FF14",
  },
  {
    num: "04",
    title: "Play & Win Rewards",
    copy: "Streaks, badges and seasonal trophies. Show up daily, stack your wins, and flex a profile nobody can ignore.",
    icon: Gift,
    color: "#8A2BE2",
  },
];

export default function Manifesto() {
  return (
    <section id="chapters" className="relative mx-auto max-w-6xl px-4 py-28 sm:px-8 sm:py-36">
      <motion.p
        initial={{ opacity: 0, y: 14 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.6 }}
        className="font-code text-xs tracking-[0.3em] text-[#64748B]"
      >
        THE MANIFESTO — 4 CHAPTERS
      </motion.p>
      <div className="mt-10">
        {chapters.map((c, i) => (
          <motion.div
            key={c.num}
            data-testid={`manifesto-chapter-${i + 1}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: 0.05 * i, ease: [0.16, 1, 0.3, 1] }}
            className="group grid grid-cols-[auto_1fr] items-start gap-5 border-t border-[#222738] py-10 transition-colors duration-300 hover:bg-[#0F111A]/60 sm:grid-cols-[120px_1fr_56px] sm:items-center sm:gap-8 sm:px-4"
          >
            <span
              className="font-display text-4xl font-extrabold sm:text-5xl"
              style={{ color: "transparent", WebkitTextStroke: `1.5px ${c.color}` }}
            >
              {c.num}
            </span>
            <div>
              <h3 className="font-display text-lg font-bold text-white transition-colors sm:text-xl" style={{}}>
                {c.title}
              </h3>
              <p className="mt-2 max-w-xl text-sm leading-relaxed text-[#94A3B8] sm:text-base">
                {c.copy}
              </p>
            </div>
            <div
              className="hidden h-14 w-14 items-center justify-center rounded-2xl border border-[#222738] transition-all duration-300 group-hover:scale-110 sm:flex"
              style={{ boxShadow: `0 0 0 rgba(0,0,0,0)` }}
            >
              <c.icon size={22} style={{ color: c.color }} />
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
